(function () {
  'use strict';

  var body = document.body;
  var POPULAR = ['Barrier mat', 'Acoustic rubber sheet', 'Pond liner', 'PVC strip curtains', 'Floor paint', 'Grass reinforcement mesh', 'Rubber flooring roll', 'Ground protection mats'];
  /* Collections that exist for search engines or discount rules, not for shoppers */
  var HIDDEN_COLLECTIONS = /near me|can't find|w\/o|locinox|all iron|bundles/i;

  var esc = function (text) {
    var holder = document.createElement('div');
    holder.textContent = text == null ? '' : String(text);
    return holder.innerHTML;
  };

  /* ---------- All drawer ---------- */
  var drawer = document.getElementById('iscn-drawer');
  var lastFocus = null;
  var openDrawer = function (trigger) {
    lastFocus = trigger;
    closePanels();
    body.classList.add('iscn-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    var close = drawer.querySelector('[data-iscn-close]');
    if (close) close.focus();
  };
  var closeDrawer = function () {
    body.classList.remove('iscn-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus) lastFocus.focus();
  };

  /* ---------- Department panels: short delays stop them flickering as the mouse crosses the row ---------- */
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-iscn-item]'));
  var openTimer = null;
  var closeTimer = null;
  var lastPointer = 'mouse';

  var setPanelTop = function () {
    var bar = document.querySelector('.nav-bar');
    if (bar) document.documentElement.style.setProperty('--iscn-panel-top', Math.max(bar.getBoundingClientRect().bottom, 44) + 'px');
  };
  var openPanel = function (item) {
    items.forEach(function (other) {
      var isThis = other === item;
      other.classList.toggle('is-open', isThis);
      other.querySelector('.iscn__top').setAttribute('aria-expanded', isThis ? 'true' : 'false');
    });
    setPanelTop();
    body.classList.add('iscn-dim');
  };
  function closePanels() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    items.forEach(function (item) {
      item.classList.remove('is-open');
      item.querySelector('.iscn__top').setAttribute('aria-expanded', 'false');
    });
    body.classList.remove('iscn-dim');
  }

  document.addEventListener('pointerdown', function (event) { lastPointer = event.pointerType || 'mouse'; }, true);

  /* The row owns closing, so crossing from one department to the next never closes the new panel */
  var row = document.querySelector('.iscn');
  if (row) {
    row.addEventListener('mouseleave', function () {
      if (lastPointer === 'touch') return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closePanels, 220);
    });
    Array.prototype.forEach.call(row.children, function (cell) {
      if (cell.hasAttribute('data-iscn-item')) return;
      cell.addEventListener('mouseenter', function () {
        if (lastPointer === 'touch') return;
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closePanels, 120);
      });
    });
  }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      if (lastPointer === 'touch') return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openPanel(item); }, body.classList.contains('iscn-dim') ? 90 : 130);
    });
    item.querySelector('.iscn__top').addEventListener('click', function (event) {
      /* First tap on a touch screen opens the panel, the panel's own button then goes to the department */
      if (lastPointer === 'touch' && !item.classList.contains('is-open')) {
        event.preventDefault();
        openPanel(item);
      }
    });
    item.addEventListener('focusin', function () {
      if (lastPointer !== 'touch') openPanel(item);
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) closeTimer = setTimeout(closePanels, 120);
    });
  });

  /* ---------- One listener for opening and closing ---------- */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-iscf-top]')) {
      window.scrollTo(0, 0);
      return;
    }
    var open = event.target.closest('[data-iscn-open]');
    if (open) {
      event.preventDefault();
      openDrawer(open);
      return;
    }
    if (event.target.closest('[data-iscn-close]') || event.target.closest('[data-iscn-scrim]')) {
      if (body.classList.contains('iscn-drawer-open')) closeDrawer();
      closePanels();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (body.classList.contains('iscn-drawer-open')) closeDrawer();
    closePanels();
    Array.prototype.forEach.call(document.querySelectorAll('[data-iscn-suggest]'), function (box) { box.hidden = true; });
  });

  /* Keeps Tab inside the open drawer */
  drawer.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = drawer.querySelectorAll('a, button, summary');
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* ---------- Sticky bar ---------- */
  /* Shows once both the header and the phone search row are out of view. Watching both keeps it right if the window crosses the phone breakpoint after loading. */
  var bar = document.getElementById('iscn-bar');
  var watched = [document.getElementById('shopify-section-header'), document.querySelector('.iscn-phone-search')].filter(Boolean);
  if (bar && watched.length && 'IntersectionObserver' in window) {
    var inView = new Map();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { inView.set(entry.target, entry.isIntersecting); });
      body.classList.toggle('iscn-bar-on', !watched.some(function (element) { return inView.get(element); }));
    });
    watched.forEach(function (element) { observer.observe(element); });
  }

  /* Basket count on the sticky bar follows the theme's count */
  var themeCount = document.querySelector('.header__cart-count');
  var barCount = document.querySelector('[data-iscn-count]');
  if (themeCount && barCount && 'MutationObserver' in window) {
    new MutationObserver(function () { barCount.textContent = themeCount.textContent.trim(); }).observe(themeCount, { childList: true, characterData: true, subtree: true });
  }

  /* ---------- Second menu row: the range being viewed is never the one that gets cut off ---------- */
  var subList = document.querySelector('.iscn-sub__list');
  var subCurrent = subList && subList.querySelector('a.is-current:not(.iscn-sub__home)');
  if (subCurrent) {
    var subItem = subCurrent.parentNode;
    if (subItem.offsetTop > subList.firstElementChild.offsetTop) subList.insertBefore(subItem, subList.children[1]);
    if (subList.scrollWidth > subList.clientWidth) subList.scrollLeft = Math.max(0, subItem.offsetLeft - 90);
  }
  var subMore = document.querySelector('.iscn-sub__more');
  if (subList && subMore) {
    var setSubMore = function () {
      if (subList.classList.contains('is-open')) return;
      subMore.hidden = false;
      subMore.hidden = subList.scrollHeight <= subList.clientHeight + 2;
    };
    subMore.addEventListener('click', function () {
      var open = subList.classList.toggle('is-open');
      subMore.setAttribute('aria-expanded', open ? 'true' : 'false');
      subMore.textContent = open ? 'Less' : 'More';
    });
    setSubMore();
    window.addEventListener('resize', setSubMore);
  }

  /* ---------- Search panel ---------- */
  var RECENT_KEY = 'isc-recent-searches';
  var SEARCH_ICON = '<svg class="iscn-suggest__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';

  var scope = { value: '', name: '' };
  var searchUrl = function (term) {
    return '/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=' + encodeURIComponent(term) + (scope.value ? '&dept=' + encodeURIComponent(scope.value) : '');
  };
  var readRecent = function () {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  };
  var writeRecent = function (list) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) { /* Private windows: recent searches simply do not appear */ }
  };
  var saveRecent = function (term) {
    term = term.trim().slice(0, 60);
    if (!term) return;
    writeRecent([term].concat(readRecent().filter(function (item) { return item.toLowerCase() !== term.toLowerCase(); })).slice(0, 5));
  };

  /* Word stems, so that "locks" also finds "Gate Lock" */
  var stemsOf = function (query) {
    return query.toLowerCase().split(/\s+/).filter(function (word) { return word.length > 1; }).map(function (word) {
      return word.length > 3 ? word.replace(/s$/, '') : word;
    });
  };
  var highlight = function (text, stems) {
    if (!stems.length) return esc(text);
    var pattern = new RegExp('(' + stems.map(function (stem) { return stem.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'ig');
    return text.split(pattern).map(function (part, index) { return index % 2 ? '<mark>' + esc(part) + '</mark>' : esc(part); }).join('');
  };

  /* The ranges in the menu, read from the drawer that is already on the page */
  var departments = [];
  var ranges = [];
  Array.prototype.forEach.call(document.querySelectorAll('.iscn-drawer__body > details.iscn-dept, .iscn-drawer__body > a.iscn-dept__link[href^="/collections"]'), function (block) {
    if (block.tagName === 'A') {
      departments.push({ title: block.textContent.trim(), url: block.getAttribute('href') });
      ranges.push({ title: block.textContent.trim(), url: block.getAttribute('href'), dept: '' });
      return;
    }
    var name = block.querySelector('summary').textContent.trim();
    var all = block.querySelector('.iscn-dept__all');
    departments.push({ title: name, url: all ? all.getAttribute('href') : '' });
    Array.prototype.forEach.call(block.querySelectorAll('ul a'), function (link) {
      ranges.push({ title: link.textContent.trim(), url: link.getAttribute('href'), dept: name });
    });
  });
  var matchRanges = function (stems) {
    return ranges.filter(function (range) {
      if (scope.name && range.dept !== scope.name) return false;
      var text = ' ' + (range.title + ' ' + range.dept).toLowerCase();
      return stems.every(function (stem) { return text.indexOf(' ' + stem) > -1; });
    }).sort(function (a, b) {
      var aTitle = stems.every(function (stem) { return (' ' + a.title.toLowerCase()).indexOf(' ' + stem) > -1; });
      var bTitle = stems.every(function (stem) { return (' ' + b.title.toLowerCase()).indexOf(' ' + stem) > -1; });
      return aTitle === bTitle ? 0 : (aTitle ? -1 : 1);
    });
  };

  var termLink = function (term, stems) {
    return '<a href="' + searchUrl(term) + '" data-term="' + esc(term) + '">' + SEARCH_ICON + '<span>' + highlight(term, stems) + '</span></a>';
  };
  var startHtml = function () {
    var recent = readRecent();
    var side = '';
    if (recent.length) {
      side += '<div class="iscn-suggest__head"><span>Recent searches</span><button type="button" data-clear-recent>Clear</button></div>' + recent.map(function (term) { return termLink(term, []); }).join('');
    }
    side += '<div class="iscn-suggest__head"><span>Popular searches</span></div>' + POPULAR.map(function (term) { return termLink(term, []); }).join('');
    var main = '<div class="iscn-suggest__head"><span>Shop by department</span></div><div class="iscn-suggest__depts">' + departments.map(function (dept) {
      return '<a href="' + esc(dept.url) + '">' + esc(dept.title) + '</a>';
    }).join('') + '</div>';
    return '<div class="iscn-suggest__cols"><div class="iscn-suggest__side">' + side + '</div><div class="iscn-suggest__main">' + main + '</div></div>';
  };
  var resultsHtml = function (query, resources) {
    var stems = stemsOf(query);
    var seen = {};
    var categories = matchRanges(stems).slice(0, 4).map(function (range) {
      seen[range.title.toLowerCase()] = true;
      return { title: range.title, url: range.url, dept: range.dept };
    });
    (resources.collections || []).forEach(function (item) {
      var title = item.title.split(' | ')[0];
      if (categories.length >= 4 || seen[title.toLowerCase()] || HIDDEN_COLLECTIONS.test(item.title)) return;
      seen[title.toLowerCase()] = true;
      categories.push({ title: title, url: item.url.split('?')[0] });
    });
    var terms = (resources.queries || []).map(function (item) { return item.text.replace(/^(premium|professional)\s+/i, ''); }).filter(function (term, index, list) {
      return term.toLowerCase() !== query.toLowerCase() && list.indexOf(term) === index;
    }).slice(0, 3);
    var products = (resources.products || []).slice(0, 5);

    if (!categories.length && !products.length) {
      return '<div class="iscn-suggest__main"><p class="iscn-suggest__none">No matches for <strong>' + esc(query) + '</strong>. Check the spelling, try a more general word, or call <a href="tel:01744520110">01744 520 110</a> and we will help you find it.</p>' +
        '<div class="iscn-suggest__head"><span>Popular searches</span></div>' + POPULAR.slice(0, 4).map(function (term) { return termLink(term, []); }).join('') + '</div>';
    }
    var side = '';
    if (terms.length) side += '<div class="iscn-suggest__head"><span>Suggestions</span></div>' + terms.map(function (term) { return termLink(term, stems); }).join('');
    if (categories.length) {
      side += '<div class="iscn-suggest__head"><span>Categories</span></div>' + categories.map(function (item) {
        return '<a href="' + esc(item.url) + '"><span class="iscn-suggest__item">' + highlight(item.title, stems) + (item.dept ? '<span class="iscn-suggest__in">in ' + esc(item.dept) + '</span>' : '') + '</span></a>';
      }).join('');
    }
    var main = '';
    if (products.length) {
      main = '<div class="iscn-suggest__head"><span>Products</span></div>' + products.map(function (item) {
        var from = parseFloat(item.price_max) > parseFloat(item.price_min) ? '<small>From </small>' : '';
        var image = item.image ? '<img src="' + esc(item.image) + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="56" height="56">' : '';
        return '<a href="' + esc(item.url.split('?')[0]) + '">' + image + '<span class="iscn-suggest__item"><span class="iscn-suggest__name">' + highlight(item.title, stems) + '</span>' +
          '<span class="iscn-suggest__price">' + from + '£' + esc(parseFloat(item.price_min || item.price).toFixed(2)) + '</span>' +
          (item.available === false ? '<span class="iscn-suggest__off">Currently unavailable</span>' : '') + '</span></a>';
      }).join('');
    }
    var cols = side && main ? '<div class="iscn-suggest__cols"><div class="iscn-suggest__side">' + side + '</div><div class="iscn-suggest__main">' + main + '</div></div>' : '<div class="iscn-suggest__main">' + side + main + '</div>';
    return cols + '<a class="iscn-suggest__more" href="' + searchUrl(query) + '" data-term="' + esc(query) + '">See all results for "' + esc(query) + '"' + (scope.name ? ' in ' + esc(scope.name) : '') + '</a>';
  };

  Array.prototype.forEach.call(document.querySelectorAll('[data-iscn-search]'), function (form) {
    var input = form.querySelector('.iscn-search__input');
    var clear = form.querySelector('.iscn-search__clear');
    var box = form.querySelector('[data-iscn-suggest]');
    var timer = null;
    var request = null;
    var select = form.querySelector('[data-iscn-dept]');
    var selectLabel = form.querySelector('[data-iscn-dept-label]');

    /* The selector only counts where it can be seen: phones do not show it */
    var readScope = function () {
      var visible = select && select.offsetParent !== null && select.value;
      scope.value = visible ? select.value : '';
      scope.name = visible ? select.options[select.selectedIndex].text : '';
    };
    var showScope = function () {
      if (select) selectLabel.textContent = select.value ? select.options[select.selectedIndex].text : 'All';
    };
    if (select) {
      /* It starts on the department the shopper is already in */
      var urlDept = new URLSearchParams(location.search).get('dept');
      var pageDept = document.querySelector('.iscn-sub');
      Array.prototype.forEach.call(select.options, function (option) {
        if (urlDept ? option.value === urlDept : (pageDept && option.text === pageDept.getAttribute('aria-label'))) select.value = option.value;
      });
      showScope();
      select.addEventListener('change', function () {
        showScope();
        input.focus();
        refresh();
      });
    }

    var setOpen = function (open) {
      box.hidden = !open;
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('iscn-sdim', open);
    };
    var refresh = function () {
      var query = input.value.trim();
      readScope();
      clear.hidden = !input.value;
      clearTimeout(timer);
      if (request) request.abort();
      form.classList.remove('is-loading');
      if (!query) {
        box.innerHTML = startHtml();
        setOpen(true);
        return;
      }
      form.classList.add('is-loading');
      timer = setTimeout(function () {
        request = new AbortController();
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last', { signal: request.signal })
          .then(function (response) { return response.json(); })
          .then(function (data) {
            form.classList.remove('is-loading');
            box.innerHTML = resultsHtml(query, data.resources.results);
            box.scrollTop = 0;
            if (document.activeElement === input || form.contains(document.activeElement)) setOpen(true);
          })
          .catch(function (error) {
            /* The form still submits to the full search page */
            if (error.name !== 'AbortError') form.classList.remove('is-loading');
          });
      }, 170);
    };

    clear.hidden = !input.value;
    input.addEventListener('focus', refresh);
    input.addEventListener('input', refresh);
    clear.addEventListener('mousedown', function (event) { event.preventDefault(); });
    clear.addEventListener('click', function () {
      input.value = '';
      input.focus();
      refresh();
    });
    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) {
        event.preventDefault();
        input.focus();
        return;
      }
      clearTimeout(timer);
      if (request) request.abort();
      saveRecent(input.value);
      readScope();
      if (select && !scope.value) select.disabled = true;
      setOpen(false);
    });
    /* Coming back with the browser's back button */
    window.addEventListener('pageshow', function () {
      if (select) select.disabled = false;
    });
    form.addEventListener('focusout', function (event) {
      if (!form.contains(event.relatedTarget)) setOpen(false);
    });
    /* Arrow keys walk through the results, Escape closes the panel */
    form.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setOpen(false);
        input.blur();
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      if (box.hidden) return;
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      var index = links.indexOf(document.activeElement);
      event.preventDefault();
      if (event.key === 'ArrowDown') {
        if (links.length) links[Math.min(index + 1, links.length - 1)].focus();
      } else if (index <= 0) {
        input.focus();
      } else {
        links[index - 1].focus();
      }
    });
    /* A click on a result must land before focus moves away */
    box.addEventListener('mousedown', function (event) { event.preventDefault(); });
    box.addEventListener('click', function (event) {
      if (event.target.closest('[data-clear-recent]')) {
        writeRecent([]);
        box.innerHTML = startHtml();
        return;
      }
      var link = event.target.closest('[data-term]');
      if (link) saveRecent(link.getAttribute('data-term'));
      if (event.target.closest('a')) setOpen(false);
    });
  });
})();
